import api from '../../api'

const SET_INSTITUTIONS = 'SET_INSTITUTIONS'
const ADD_INSTITUTION = 'ADD_INSTITUTION'

export default {
  namespaced: true,
  state: {
    institutions: {}
  },
  getters: {
    isInstitutionsLoaded (state) {
      return Object.values(state.institutions).length > 0
    },
    getInstitutions (state) {
      return state.institutions
    },
  },
  mutations: {
    [SET_INSTITUTIONS] (state, institutions) {
      state.institutions = institutions
    },
    [ADD_INSTITUTION] (state, institution) {
      let item = {}
      item[institution.code] = institution
      state.institutions = Object.assign({}, state.institutions, item)
    }
  },
  actions: {
    loadInstitutions: async ({ commit }) => {
      let response = await api.institutions.list()
      if (response.success) {
        commit(SET_INSTITUTIONS, response.institutions)
      } else {
        throw new Error(response.message || 'Произошла ошибка при загрузке списка институтов')
      }
    },
    getInstitutions: async ({ commit }) => {
      let response = await api.institutions.list()
      if (response.success) {
        commit(SET_INSTITUTIONS, response.institutions)
      } else {
        throw new Error(response.message || 'Произошла ошибка при загрузке списка институтов')
      }
    },
    getInstitution: async ({ commit }, code) => {
      let response = await api.institutions.institution(code)
      if (response.success) {
        commit(ADD_INSTITUTION, response.institution)
      }
    },
    saveInstitution: async ({commit}, institution) => {
      let response = await api.institutions.save(institution)
      if (response.success) {
        commit(ADD_INSTITUTION, response.institution)
      }
    }
  },
}
